import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import {
    DesignerIcon,
    MappingIcon,
    MatrixIcon,
    ProjectIcon,
} from '../../Globle/Icon';
import { STEP_TYPE } from '../../../__utils/UiConst';
import RoundedButton from '../../Globle/RoundedButton';

const Sidebar = observer(() => {
    const { uiManager, viewManager } = useMainContext();
    const stepButtons = [
        {
            label: 'Project Creation',
            icon: <ProjectIcon />,
            value: STEP_TYPE.CREATE,
            disabled: viewManager.projectId ? true : false,
            onClick: () => {},
        },
        {
            label: 'Mapping',
            icon: <MappingIcon />,
            value: STEP_TYPE.MAPPING,
            disabled: !viewManager.projectId,
            onClick: () => {
                uiManager.setSelectedStep(STEP_TYPE.MAPPING);
                viewManager.setSelectedMenu(2);
            },
        },
        {
            label: 'MATRIX',
            icon: <MatrixIcon />,
            value: STEP_TYPE.MATRIX,
            disabled: !viewManager.projectId,
            onClick: () => {
                // uiManager.setSelectedStep(STEP_TYPE.MATRIX);
                // viewManager.setSelectedMenu(3);
            },
        },
        {
            label: 'Designer',
            icon: <DesignerIcon />,
            value: STEP_TYPE.DESIGNER,
            disabled: !viewManager.projectId,
            onClick: () => {
                // uiManager.setSelectedStep(STEP_TYPE.DESIGNER);
                // viewManager.setSelectedMenu(4);
            },
        },
    ];
    return (
        <div className="h-full w-[80px] p-[16px] flex flex-col gap-[8px]">
            {stepButtons.map((button) => {
                return (
                    <RoundedButton
                        key={button.value}
                        icon={button.icon}
                        disabled={button.disabled}
                        isActive={uiManager.selectedStep === button.value}
                        onClick={() => {
                            if (!button.disabled) {
                                button.onClick();
                            }
                        }}
                        className={`w-[48px] h-[48px] ${
                            button.disabled
                                ? 'pointer-events-none'
                                : 'pointer-events-none'
                        }`}
                    />
                );
            })}
        </div>
    );
});

export default Sidebar;
